export default ["M9.96 0a10 10 0 100 20 10 10 0 100-20z"];
//# sourceMappingURL=full-circle.js.map